import React, { useReducer } from 'react';
import taskContext from './taskContext';
import TaskReducer from './taskReducer';
//import { v4 as uuidv4 } from 'uuid';

import { 
    TASK_PROJECT,
    ADD_TASK, 
    VALIDATE_TASK,
    DELETE_TASK,
    //TASK_STATUS,
    ACTUAL_TASK,
    UPDATE_TASK,
    CLEAN_TASK
} from '../../types';
import axiosClient from '../../config/axios';

const TaskState = props => {
    
    const initialState = {
        projectTasks: [],
        errorTask: false,
        selectedTask: null
    }

    // Create state and dispatch
    const [ state, dispatch ] = useReducer(TaskReducer, initialState);

    // Crate functions

    // Get tasks of project
    const getTasks = async project => {
        try {
            const response = await axiosClient.get('/api/tasks', { params: { project } });
            //console.log(response.data.tasks);
            dispatch({
                type: TASK_PROJECT,
                payload: response.data.tasks
            });
        } catch (error) {
            console.log('Error:', error);
        }
    }
    
    // Add a task to the selected project
    const addTask = async task => {
        //task.id = uuidv4();
        try {
            const response = await axiosClient.post('/api/tasks', task);
            console.log(response);
            dispatch({
                type: ADD_TASK,
                payload: task
            });
        } catch (error) {
            console.log('Error:', error);
        }
    }

    // Validates and show an error if is necessary
    const validateTask = () => {
        dispatch({
            type: VALIDATE_TASK
        })
    }

    // Delete task by ID
    const deleteTask = async (taskID, project) => {
        try {
            await axiosClient.delete(`/api/tasks/${ taskID }`, { params: { project } });
            dispatch({
                type: DELETE_TASK,
                payload: taskID
            });
        } catch (error) {
            console.log('Error', error);
        }
    }

    // Change the status of a task
    // const changeStatusTask = task => {
    //     dispatch({
    //         type: TASK_STATUS,
    //         payload: task
    //     })
    // }

    // Extracts a task for edition
    const setActualTask = task => {
        dispatch({
            type: ACTUAL_TASK,
            payload: task
        })
    }

    // Update a task
    const updateTask = async task => {
        try {
            const response = await axiosClient.put(`/api/tasks/${ task._id }`, task);
            console.log(response.data.task);
            dispatch({
                type: UPDATE_TASK,
                payload: task
            })
        } catch (error) {
            console.log('Error:', error);
        }
    }

    // Clean the selected task from state
    const cleanTask = () => {
        dispatch({
            type: CLEAN_TASK
        })
    }

    return (
        <taskContext.Provider
            value={{
                //tasks: state.tasks,
                projectTasks: state.projectTasks,
                errorTask: state.errorTask,
                selectedTask: state.selectedTask,
                getTasks,
                addTask,
                validateTask,
                deleteTask,
                //changeStatusTask,
                setActualTask,
                updateTask,
                cleanTask
            }}
        >
            { props.children }
        </taskContext.Provider>
    )
}

export default TaskState;